import React, { useState } from 'react';
import axios from 'axios';
import LazyLoader from '../../components/LazyLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Paper from '@mui/material/Paper';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import { green } from '@mui/material/colors';
import Rating from '@mui/material/Rating';
import StarRatings from 'react-star-ratings';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(1, 2, 0, 0),
    fontSize: '12px',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      margin: theme.spacing(1, 0),
      width: '50%',
    },
  },
  dialogButton: {
    margin: theme.spacing(1, 0),
  },
  green: {
    color: '#fff',
    backgroundColor: green[500],
  },
  paper: {
    maxWidth: '100%',
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
  commentName: {
    fontSize: '12px',
    fontWeight: '700',
  },
  commentDate: {
    fontSize: '12px',
    fontWeight: '400',
  },
  commentContent: {
    fontSize: '14px',
    fontWeight: '400',
  },
  commentReview: {
    width: 'calc(50ch + 16px)',
    maxWidth: '95%',
  },
}));

const Comments = (props) => {
  const [rating, setRating] = useState(5);
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [alertOpen, setAlertOpen] = React.useState(false); /*open message*/

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div>
        <Button variant="outlined" color="primary" onClick={handleClickOpen} className={classes.dialogButton}>
          Add A Review
        </Button>
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Add a review</DialogTitle>
          <DialogContent>
            <DialogContentText>Please wait 3-5 seconds before the review is uploaded successfully.</DialogContentText>
            <Formik
              initialValues={{ name: '', email: '', message: '' }}
              validationSchema={Yup.object({
                name: Yup.string().min(3, 'Too short name').max(40, 'Too long name').required('Required'),
                email: Yup.string().email('Invalid email address').required('Required'),
                message: Yup.string().max(150, 'Too many >150 characters').required('Required'),
              })}
              onSubmit={(values) => {
                // console.log(values);
                axios
                  .post('https://staticmanreview.netlify.app/.netlify/functions/submit-comment', {
                    fields: {
                      program: 'pagani',
                      slug: `${props.slug}`,
                      rating: rating,
                      name: `${values.name}`,
                      message: `${values.message}`,
                      email: `${values.email}`,
                    },
                  })
                  .then((response) => {
                    // console.log(response);
                    setAlertOpen(true);
                  });
              }}>
              {(formik) => (
                <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
                  <StarRatings
                    rating={rating}
                    starRatedColor="#ffd100"
                    starHoverColor="#ffd100"
                    changeRating={(newRating, name) => {
                      setRating(newRating);
                    }}
                    numberOfStars={5}
                    starDimension="20px"
                    name="rating"
                  />

                  <TextField
                    multiline
                    rowsMax={5}
                    margin="dense"
                    id="message"
                    label="Review"
                    name="message"
                    type="text"
                    className={classes.commentReview}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...formik.getFieldProps('message')}
                  />
                  {formik.touched.message && formik.errors.message ? <div style={{ color: '#f00' }}>{formik.errors.message}</div> : null}
                  <TextField
                    id="name"
                    label="Name"
                    name="name"
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...formik.getFieldProps('name')}
                  />
                  {formik.touched.name && formik.errors.name ? <div style={{ color: '#f00' }}>{formik.errors.name}</div> : null}
                  <TextField
                    id="email"
                    label="Email"
                    name="email"
                    type="email"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...formik.getFieldProps('email')}
                  />
                  {formik.touched.email && formik.errors.email ? <div style={{ color: '#f00' }}>{formik.errors.email}</div> : null}
                  <Button variant="contained" color="primary" type="submit" size="small">
                    Submit
                  </Button>
                </form>
              )}
            </Formik>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={alertOpen}
              autoHideDuration={2000}
              onClose={handleAlertClose}>
              <Alert onClose={handleAlertClose} variant="filled" severity="success">
                Thanks for your review, we'll publish it at next update!
              </Alert>
            </Snackbar>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Typography className={classes.commentName}>Latest Reviews({props.comments.length})</Typography>
      <Divider />
      <div className={classes.root}>
        {props.comments && props.comments.length ? (
          <TableContainer component={Paper} sx={{ minHeight: '200px' }}>
            <LazyLoader priority={LazyLoader.Priority.LOW}>
              <Table aria-label="simple table">
                <TableBody>
                  {props.comments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((comment) => (
                    <Paper elevation={1} className={classes.paper} key={comment.node._id}>
                      <Grid
                        container
                        wrap="nowrap"
                        spacing={2}
                        sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                        <Grid item sx={{ width: 'max-content' }}>
                          <Avatar className={classes.green}>{comment.node.name.substring(0, 1).toUpperCase()}</Avatar>
                        </Grid>

                        <Grid item sx={{ flexGrow: 1, ml: '0.2rem' }}>
                          <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            {comment.node.name.split(' ').length > 1 ? (
                              <Typography className={classes.commentName}>
                                {comment.node.name.split(' ')[0]} {comment.node.name.split(' ')[1][0].toUpperCase()}.
                              </Typography>
                            ) : (
                              <Typography className={classes.commentName}>{comment.node.name}.</Typography>
                            )}
                            <Typography className={classes.commentDate}>{new Date(comment.node.date).toLocaleDateString()}</Typography>
                          </Grid>
                          <Grid container sx={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                            <Rating name="read-only" precision={0.5} value={comment.node.rating} size="small" readOnly />
                            {/*<Typography className={classes.commentDate}>Verified Buyer</Typography>*/}
                          </Grid>
                          {comment.node.message.split('\n').map((paragraph, index) => (
                            <Typography className={classes.commentContent} key={index}>
                              {paragraph}
                            </Typography>
                          ))}
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10]}
                component="div"
                count={props.comments.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </LazyLoader>
          </TableContainer>
        ) : (
          <p>No reviews.</p>
        )}
      </div>
    </>
  );
};

export default Comments;
